import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoDropdownComponent } from 'ngx-eo-web-components';
import { STATUS } from '../../../core/models/loading-status.enum';
import { Drg } from '../../../core/models/drg.model';
import { DrgService } from '../../../../services/drgs/drgs-service.service';
// import { da } from 'date-fns/locale';

@Component({
  selector: 'app-drg-dropdown',
  templateUrl: './drg-dropdown.component.html',
  styleUrls: ['./drg-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DrgDropdownComponent),
      multi: true,
    },
  ],
})
export class DrgDropdownComponent extends EoDropdownComponent<Drg> {
  @Input() override label = 'DRG';
  @Input() override optionLabel = 'drgCodeWithName';
  @Input() override optionValue = 'id';
  @Input() override placeholder = 'Όλα τα DRG';
  @Input() override filterPlaceholder = 'Αναζήτηση με κωδικό - όνομα';
  @Input() override filterBy = 'drgCodeWithName';
  override options: any;
  drgListCallHandler = this.drgService.drgListCallHandler;

  constructor(private readonly drgService: DrgService) {
    super();
  }

  override ngOnInit() {
    this.drgService.getAllDrgs().subscribe((data) => {
      this.groupDrgsBySurgeryImportance(data);
    });
  }

  private groupDrgsBySurgeryImportance(data: Drg[]) {
    const groupedData = data.reduce(
      (acc: { [key: string]: Drg[] }, item: Drg) => {
        const key = item.surgeryImportanceOptionName;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push({
          ...item,
        });
        return acc;
      },
      {}
    );

    this.options = Object.keys(groupedData).map((key) => ({
      label: key,
      items: groupedData[key],
    }));
  }

  override hasFilter(): boolean {
    return true;
  }

  override isLoading(): boolean {
    return this.drgListCallHandler.status$.getValue() === STATUS.loading;
  }
}
